import React, { useCallback } from "react";
import { connect } from "react-redux";

import { Redirect, useLocation } from "react-router-dom";

import { AuthLayout } from "@mapmycustomers/auth";

import configService from "@app/config/ConfigService";
import Path from "@app/enum/Path";
import UserRequestStatus from "@app/enum/sso/UserRequestStatus";
import { fetchTokenHandoffCode } from "@app/store/app/actions";
import { getLinkExpired, getUserRequestStatus } from "@app/store/auth";
import authService from "@app/store/auth/AuthService";
import { RootState } from "@app/store/rootReducer";
import { openLegacyAppInNewTab } from "@app/util/openLegacyApp";

import LinkExpiredPage from "./LinkExpiredPage";
import ManageUserAccessPage from "./ManageUserAccessPage";
import RequestStatusPage from "./RequestStatusPage";

interface Props {
  linkExpired: boolean;
  userRequestStatus?: UserRequestStatus;
}

const ManageUserAccess = ({
  linkExpired,
  onFetchTokenHandoffCode,
  userRequestStatus,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const sessionCode = urlParams.get("mmc_session_id");
  const baseOldAppUrl = configService.getBaseOldAppUrl();
  const token = authService.getToken();

  const handleManageUsersClick = useCallback(() => {
    openLegacyAppInNewTab(onFetchTokenHandoffCode, baseOldAppUrl, token, "/dashboard/teams");
  }, [baseOldAppUrl, onFetchTokenHandoffCode, token]);

  if (!sessionCode) {
    return <Redirect to={Path.DASHBOARD} />;
  }
  return (
    <AuthLayout>
      {linkExpired ? (
        <LinkExpiredPage onManageUsersClick={handleManageUsersClick} />
      ) : userRequestStatus ? (
        <RequestStatusPage onManageUsersClick={handleManageUsersClick} status={userRequestStatus} />
      ) : (
        <ManageUserAccessPage
          onManageUsersClick={handleManageUsersClick}
          sessionCode={sessionCode}
        />
      )}
    </AuthLayout>
  );
};

const mapStateToProps = (state: RootState) => ({
  linkExpired: getLinkExpired(state),
  userRequestStatus: getUserRequestStatus(state),
});

const mapDispatchToProps = {
  onFetchTokenHandoffCode: fetchTokenHandoffCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserAccess);
